/*
 * Full-diagnostic endpoints on the legacy gateways, staged like the session
 * engine (2026-09-23): `npm start` hits the Development stage (dev aliases,
 * $LATEST) and deployed builds hit Production (prod aliases, pinned
 * versions). See API_STAGE in ../config/api.js.
 *
 * gradeDiagnostic and updateUser keep their no-stage URLs: their Development
 * routes still point at the prod aliases, so staging them changes nothing.
 */
import { API_STAGE } from '../config/api';

const HOMEWORK_BASE = `https://fm407nxajh.execute-api.us-west-2.amazonaws.com/${API_STAGE}`;
const TUTOR_BASE = `https://gyxyzs5421.execute-api.us-east-1.amazonaws.com/${API_STAGE}`;

export const GET_DIAGNOSTIC_URL = `${HOMEWORK_BASE}/getDiagnostic`;
export const GET_DIAGNOSTIC_SCORE_URL = `${HOMEWORK_BASE}/getDiagnosticScore`;
export const SUBMIT_DIAGNOSTIC_SECTION_URL = `${HOMEWORK_BASE}/submitDiagnosticSection`;
export const SAVE_PROGRESS_URL = `${HOMEWORK_BASE}/saveProgress`;
export const DIAGNOSTIC_HEARTBEAT_URL = `${TUTOR_BASE}/handleDiagnosticHeartbeat`;
